import Layout from './Layout'
import './Layout.css'

export default Layout



// WEBPACK FOOTER //
// ./src/features/Feedback/components/Layout/index.js